import React from "react";
import { useNavigate } from "react-router-dom";
import { resolveImg } from "@/lib/api";
import { fmtRent } from "@/lib/constants";
import { MapPin, Users } from "lucide-react";

const FALLBACK = "https://images.unsplash.com/photo-1625241152315-4a698f74ceb7?w=200";

export function TribeCard({ tribe }) {
  const navigate = useNavigate();
  const members = tribe.members || [];
  const spotsLeft = Math.max(0, (tribe.spots || 0) - members.length);
  return (
    <div
      data-testid={`tribe-card-${tribe.tribe_id}`}
      onClick={() => navigate(`/tribe/${tribe.tribe_id}`)}
      className="cursor-pointer rounded-3xl bg-white p-5 shadow-card transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="flex items-start justify-between">
        <span className="rounded-full bg-sun/20 px-2.5 py-1 text-xs font-bold text-ink">
          {spotsLeft > 0 ? `Looking for ${spotsLeft}` : "Full"}
        </span>
        <span className="rounded-full bg-secondary px-2.5 py-1 text-xs font-semibold text-ink-soft">{tribe.target_config}</span>
      </div>
      <h4 className="mt-3 font-heading text-lg font-extrabold text-ink">{tribe.title}</h4>
      <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm text-ink-soft">
        <span className="flex items-center gap-1"><MapPin className="h-4 w-4 text-brand" /> {(tribe.preferred_localities || []).join(", ")}</span>
      </div>
      <p className="mt-1 text-sm font-semibold text-ink">{fmtRent(tribe.budget_min)}–{fmtRent(tribe.budget_max)} <span className="font-normal text-ink-soft">per person</span></p>
      <div className="mt-4 flex items-center justify-between">
        <div className="flex -space-x-3">
          {members.slice(0, 4).map((m) => (
            <img key={m.user_id} src={resolveImg(m.profile?.photo_url) || FALLBACK} alt="" className="h-9 w-9 rounded-full border-2 border-white object-cover" />
          ))}
          {members.length > 4 && <span className="grid h-9 w-9 place-items-center rounded-full border-2 border-white bg-ink text-xs font-bold text-white">+{members.length - 4}</span>}
        </div>
        <span className="flex items-center gap-1 text-xs font-semibold text-brand"><Users className="h-4 w-4" /> {members.length} in tribe</span>
      </div>
    </div>
  );
}
